import { t } from "@/i18n-js/instance";
import { ExecutePreviewCard } from "./ExecutePreviewCard";

export interface InviteLinkExecutePreviewProps {
  members_joined_count?: number;
  name?: string;
  status?: string;
}

export const InviteLinkExecutePreview = ({
  name,
  status,
  members_joined_count,
}: InviteLinkExecutePreviewProps) => {
  const membersJoinedText =
    members_joined_count != null
      ? t("help_widget.copilot.execute_preview.members_count", {
          count: members_joined_count,
        })
      : undefined;

  return (
    <ExecutePreviewCard
      title={t("help_widget.copilot.execute_preview.invite_link_title")}
      attributes={[
        {
          label: t("help_widget.copilot.execute_preview.name"),
          value: name,
        },
        {
          label: t("help_widget.copilot.execute_preview.status"),
          value: status,
        },
        {
          label: t(
            "help_widget.copilot.execute_preview.number_of_members_joined",
          ),
          value: membersJoinedText,
        },
      ]}
    />
  );
};
